import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'btx-interest-info',
  templateUrl: './interest-info.component.html',
  styleUrls: ['./interest-info.component.scss'],
  standalone: false
})
export class InterestInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
